import * as yup from 'yup';

/**
 * Схема формы телефона.
 */
export const schema = yup.object().shape({
  /**
   * Сумма платежа не может быть пустой
   */
  code: yup
    .string()
    .required('Введите код')
    .matches(/^\d{4}/, 'Введен неверный код'),
});

/**
 * Значения схемы.
 */
export type Values = yup.InferType<typeof schema>;
